import {
    AdvancedFiltersState,
    DataGridAdvancedFilterExtended,
} from 'common/context/DataGridAdvancedFilterContext';
import { QUOTE_TYPE } from 'common/stores/redux/MetaStore/MetaStoreApi.types';

export const isOrderQuote = (quoteTypeId?: QUOTE_TYPE) => {
    if (!quoteTypeId) return false;
    return [QUOTE_TYPE.EQUIPMENT_ONLY].includes(quoteTypeId);
};

/**
 * Calculates which issue reason and secondary reason filters should be removed
 * when issue filters change
 */
export const calculateQuoteExceptionChildrenChanges = (
    newFilters: Partial<AdvancedFiltersState>,
    advancedFilters: Partial<AdvancedFiltersState>
) => {
    const currentIssueIds = Array.isArray(newFilters)
        ? newFilters.map(issue => (issue.form ? issue.form.id : issue.id))
        : [];

    const updatedIssueReasons = advancedFilters.issueReason?.filter(reason =>
        currentIssueIds.includes(reason.form?.parentId)
    );
    const updatedIssueReasonIds = updatedIssueReasons?.map(
        reason => reason.form?.id
    );
    const updatedIssueSecondaryReasons =
        advancedFilters.issueSecondaryReason?.filter(reason =>
            updatedIssueReasonIds?.includes(reason.form?.parentId?.toString())
        );

    const updates: {
        issueReason?: DataGridAdvancedFilterExtended<'select'>[];
        issueSecondaryReason?: DataGridAdvancedFilterExtended<'select'>[];
    } = {};

    // Only include updates if they're different from current filters
    if (
        JSON.stringify(
            advancedFilters.issueReason?.map(issue => issue.term)
        ) !== JSON.stringify(updatedIssueReasonIds)
    ) {
        updates.issueReason = updatedIssueReasons;
    }
    if (
        JSON.stringify(
            advancedFilters.issueSecondaryReason?.map(issue => issue.term)
        ) !==
        JSON.stringify(updatedIssueSecondaryReasons?.map(reason => reason.term))
    ) {
        updates.issueSecondaryReason = updatedIssueSecondaryReasons;
    }

    return updates;
};

/**
 * Calculates which secondary reason filters should be removed
 * when issue reason filters change
 */
export const calculateQuoteExceptionReasonChildrenChanges = (
    // @ts-ignore
    newFilters,
    // @ts-ignore
    advancedFilters
) => {
    const currentReasonIds =
        // @ts-ignore
        newFilters?.map(issue => (issue.form ? issue.form.id : issue.id)) || [];

    const updatedIssueSecondaryReasons = // @ts-ignore
        advancedFilters.issueSecondaryReason?.filter(reason =>
            currentReasonIds.includes(reason.form.parentId)
        );

    return {
        issueSecondaryReason: updatedIssueSecondaryReasons,
    };
};
